import { jsonMember, jsonObject } from 'typedjson';
import { Guid } from '@web/utils';
import { BoxQuestionnaireStatus } from '../../../shared/enums';

@jsonObject
export class PublicBoxRecommendedQuestionnaireResponse {
  @jsonMember(String)
  public readonly id!: Guid;

  @jsonMember(String)
  public readonly name!: string;

  @jsonMember(String)
  public readonly status!: BoxQuestionnaireStatus;
}
